import { z as builder } from "zod"

export const unlockSchema = builder.object({
    phoneNumber: builder
        .string()
        .min(1, "Este campo es obligatorio")
        .min(10, "Ingresa un número de 10 dígitos")
        .max(10, "Ingresa un número de 10 dígitos"),
})

export type UnlockSchema = builder.infer<typeof unlockSchema>
